// import React from "react";
// import { BrowserRouter } from "react-router-dom";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
// import { base_path } from "./environment.jsx";
// import "../src/style/css/feather.css";
// import "../src/style/css/line-awesome.min.css";
// import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
// import "../src/style/scss/main.scss";
// import "../src/customStyle.scss";
// import "../src/style/icons/fontawesome/css/fontawesome.min.css";
// import "../src/style/icons/fontawesome/css/all.min.css";
// import "../src/style/fonts/feather/css/iconfont.css";
// import { createRoot } from "react-dom/client";
// import "./i18n"; // Import the i18n config
// import { Provider } from "react-redux";
// import store from "./core/redux/store.jsx";
// import AllRoutes from "./Router/router.jsx";

// const rootElement = document.getElementById("root");

// if (rootElement) {
//   const root = createRoot(rootElement);
//   root.render(
//     <React.StrictMode>
//       <Provider store={store}>
//         <BrowserRouter basename={base_path}>
//           <AllRoutes />
//         </BrowserRouter>
//       </Provider>
//     </React.StrictMode>
//   );
// } else {
//   console.error("Element with id 'root' not found.");
// }





import React, { useState, createContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
import "../src/style/scss/main.scss";
import "../src/customStyle.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/fonts/feather/css/iconfont.css";
import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import "./i18n"; 
import AllRoutes from "./Router/router.jsx";

export const Context = createContext({
  isAuthorizedHealthCheck: false,
  setIsAuthorizedHealthCheck: () => {},
  HealthCheckuser: null,
  setHealthCheckuser: () => {},
});

const AppRoot = () => {
  const [isAuthorizedHealthCheck, setIsAuthorizedHealthCheck] = useState(
    sessionStorage.getItem("isAuthorizedHealthCheck") === "true"
  );

const [HealthCheckuser, setHealthCheckuser] = useState(() => {
  const storedUser = sessionStorage.getItem("HealthCheckuser");
  return storedUser ? JSON.parse(storedUser) : null;
});

  return (
     <Provider store={store}>
    <Context.Provider
      value={{ isAuthorizedHealthCheck, setIsAuthorizedHealthCheck, HealthCheckuser, setHealthCheckuser }}
    >
      <BrowserRouter basename={base_path}>
        <AllRoutes />
      </BrowserRouter>
    </Context.Provider>
    </Provider>
  );
};

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <AppRoot />
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
